// Vite DEV: same-origin '' → /api via proxy. Prod build keeps placeholder for start.sh sed.
export const CHAPCHE_API_URL = import.meta.env.DEV ? '' : 'BACKEND_API_URL';

export const PROFILE_TAB = 'profile';
export const USERS_TAB = 'user';
export const PRODUCT_TAB = 'product';
export const RECIPE_TAB = 'recipe';
export const PREFERENCE_TAB = 'preference';
export const GENERATION_TRACE_TAB = 'generation-trace';
export const REFERENCE_BOOKS_TAB = 'reference-books';
export const GRAIN_LIQUID_RATIOS_TAB = 'grain-liquid-ratios';
export const SVG_LIBRARY_TAB = 'svg-library';

export const ADMIN_ROLE = 'admin';
export const GUEST_ROLE = 'guest';

export const ADMIN_CONSOLE_BUSINESS_OBJECT = 'admin_console';
export const CABINET_BUSINESS_OBJECT = 'cabinet';

export const ERROR_WRONG_EMAIL_TYPE = 'email';
export const ERROR_WRONG_ROLE_TYPE = 'roleId';

export const CREATE_PERMISSIONS = 'createPermission';
export const READ_PERMISSIONS = 'readPermission';
export const UPDATE_PERMISSIONS = 'updatePermission';
export const DELETE_PERMISSIONS = 'deletePermission';

export const PAGE_TAB_NAME_LIST = 'list';
export const PAGE_TAB_NAME_COMPOSITION_TREE = 'composition-tree';
export const PAGE_TAB_NAME_NEW = 'new';

export const LOCALE_EN = 'en';
export const LOCALE_RU = 'ru';

export const ONE_MINUTE_NUMBER = 60000;
export const ONE_HOUR_NUMBER = 60;
export const ONE_DAY = 24 * 60 * 60 * 1000;

export const SORTING_DIRECTION_ASC = 'asc';
export const SORTING_DIRECTION_DESC = 'desc';

export const MOUSE_DOWN_EVENT = 'mousedown';
export const KEY_UP_EVENT = 'keyup';
export const CHANGE_VISIBILITY_EVENT = 'visibilitychange';
export const VISIBILITY_STATE_VISIBLE = 'visible';

export const ERROR_TYPE_LOGIN = 'login';
export const ERROR_TYPE_PASSWORD = 'password';
export const ERROR_WRONG_PHONE_TYPE = 'phone';

export const FORM_TAB_NAME = 'form';
export const ITEM_TAB_NAME = 'item';
export const PROPERTY_TAB_NAME = 'property';
export const COOKING_STEP_TAB_NAME = 'cookingStep';
export const PHRASE_TAB_NAME = 'phrase';
export const MEAL_TAB_NAME = 'meal';
export const GROUP_TAB_NAME = 'group';

export const ACTIVE_MODAL_ITEM_EMAIL = 'email';
export const ACTIVE_MODAL_ITEM_PASSWORD = 'password';

export const PERMISSION_LEVEL_COMPONENT = 'component';
export const PERMISSION_LEVEL_BUSINESS_OBJECT = 'business_object';

export const POPUP_KEY_DELETE_PRODUCT = 'delete-product';
export const POPUP_KEY_DELETE_PROPERTY = 'delete-property';
export const POPUP_KEY_DELETE_FORM = 'delete-form';
export const POPUP_KEY_CREATE_FORM = 'create-form';
export const POPUP_KEY_CREATE_PROPERTY = 'create-property';
export const POPUP_KEY_CREATE_PRODUCT = 'create-product';
export const POPUP_KEY_ADD_PROPERTY = 'add-property';
export const POPUP_KEY_DELETE_PREFERENCE = 'delete-preference';
export const POPUP_KEY_CREATE_INGREDIENT = 'create-ingredient';
export const POPUP_KEY_RESTORE_PRODUCT = 'restore-product';
export const POPUP_KEY_RESTORE_PROPERTY = 'restore-property';
export const POPUP_KEY_RESTORE_FORM = 'restore-form';
export const POPUP_KEY_ASSIGN_GROUP = 'assign-group';
export const POPUP_KEY_DELETE_RECIPE = 'delete-recipe';
export const POPUP_KEY_CREATE_RECIPE = 'create-recipe';
export const POPUP_KEY_ADD_INGREDIENT_TO_RECIPE = 'add-ingredient-to-recipe';
export const POPUP_KEY_DELETE_INGREDIENT = 'delete-ingredient';
export const POPUP_KEY_CREATE_COOKING_STEP = 'create-cooking-step';
export const POPUP_KEY_DELETE_COOKING_STEP = 'delete-cooking-step';
export const POPUP_KEY_DELETE_PRODUCT_PROPERTY = 'delete-product-property';
export const POPUP_KEY_DELETE_PREFERENCE_GROUP = 'delete-preference-group';
export const POPUP_KEY_DELETE_PHRASE = 'delete-phrase';

export const PROPERTY_TYPE_NUMBER = 'number';
export const PROPERTY_TYPE_SELECT = 'select';
export const PROPERTY_TYPE_BOOLEAN = 'boolean';
export const PROPERTY_TYPE_STRING = 'string';

export const MIN_PREFIX = 'min';
export const MAX_PREFIX = 'max';

export const RECIPE_INGREDIENT_TYPE_PRODUCT = 'product';
export const RECIPE_INGREDIENT_TYPE_CEREAL_MIX = 'cereal-mix';

export const RECIPE_INGREDIENT_GROUP_BASE = "base";
export const RECIPE_INGREDIENT_GROUP_ADDS = "adds";
export const RECIPE_INGREDIENT_GROUP_TASTY = "tasty";
export const RECIPE_INGREDIENT_GROUP_LIQUID = "liquid";

export const PRODUCT_FORM_GRAIN = 'grain';
export const PRODUCT_FORM_LIQUID = 'liquid';

export const ITEM_COUNT_SMALL_WIDTH = 9;
export const ITEM_COUNT_FULL_WIDTH = 8;
export const PRODUCT_COUNT_SMALL_WIDTH = 8;
export const PRODUCT_COUNT_FULL_WIDTH = 10;

export const DEFAULT_PHRASES_COUNT = 50;
export const TABLE_PHRASES_COUNT = 5000;

export const SMALL_PART_PHRASES_COUNT = 10;

export const CHECK_ITEM_CODE_REG_EXP = /^[A-Za-z0-9-_]+$/gm;
export const DIGITS_REG_EXP = /^[\.,0-9]*$/;
export const DATE_REG_EXP = /^\d*\.?\d*$/;
export const NON_DIGITS_REG_EXP = /\D/g;

export const SELECT_WITH_SEARCH_LIMIT = 5;
export const FILTER_TYPE_CHECKBOX = 'checkbox';
export const FILTER_TYPE_SELECT = 'select';
export const FILTER_TYPE_MAX_AND_MIN = 'maxAndMin';
export const FILTER_NAME_IS_DELETED = 'isDeleted';
export const FILTER_NAME_IS_NOT_VALID = 'isNotValid';
export const FILTER_GROUP_NAME_STATUS = 'status';

export const PAGINATION_ITEM_TYPE_THREE_DOTS = 'three-dots';
export const PAGINATION_ITEM_TYPE_PAGE_NUMBER = 'page-number';
export const PAGINATION_ITEM_TYPE_NEXT_PAGE = 'next-page';
export const PAGINATION_ITEM_TYPE_LAST_PAGE = 'last-page';

export const COMMIT_FRONTEND = 'LAST_COMMIT_FRONTEND';
export const COMMIT_BACKEND = 'LAST_COMMIT_BACKEND';

export const CHAPCHE_WEBSOCKET_URL = import.meta.env.DEV ? '' : 'WEBSOCKET_API_URL';

export const YANDEX_BROWSER = 'YaBrowser';
export const SAFARI_BROWSER = 'Safari';

export const PREFERENCE_GROUP_ACTIVITY_PERIOD_ALWAYS = 'always';
export const PREFERENCE_GROUP_ACTIVITY_PERIOD_SELECTED = 'activityPeriods';

export const DATE_START_LABEL = 'from';
export const DATE_STOP_LABEL = 'to';
export const DATE_START_KEY = 'dateStart';
export const DATE_STOP_KEY = 'dateStop';

export const currentPermissions = [
    {
        key: CREATE_PERMISSIONS,
        title: 'Создание',
    },
    {
        key: READ_PERMISSIONS,
        title: 'Чтение',
    },
    {
        key: UPDATE_PERMISSIONS,
        title: 'Редактирование',
    },
    {
        key: DELETE_PERMISSIONS,
        title: 'Удаление',
    },
    {
        key: 'viewAllPermission',
        title: 'Просмотр всех',
    },
    {
        key: 'modifyAllPermission',
        title: 'Изменение всех',
    },
];

export const AUTH_PERMISSION = 'auth';

export const I18N_CODE_VALIDATION_ERROR = 'app.page.product.checkFormError';
export const I18N_CODE_EXISTS_ERROR = 'app.page.product.checkCodeExists';
export const I18N_CODE_DELETED_PRODUCT_ERROR = 'app.page.product.checkCodeDeleted';
export const I18N_CODE_DELETED_FORM_ERROR = 'app.page.product.form.checkCodeDeleted';
export const I18N_CODE_DELETED_PROPERTY_ERROR = 'app.page.product.property.checkCodeDeleted';

export const TABLET_WIDTH = 1024;
/** Below this width list/table mode is forced to tile (phone). Tablet (≥768) keeps the switcher. */
export const LIST_TABLE_MIN_WIDTH = 768;
export const SMALL_WEB_SCREEN_WIDTH = 1456;

export const NOTIFICATION_TYPE_INFO = 'info';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_WARNING = 'warning';

export const NOTIFICATION_EVENT_TYPE_PHRASES_GENERATED = 'phrases-generated';
export const NOTIFICATION_EVENT_TYPE_PHRASES_UPDATED_FAIL = 'preference-phrase-updated-fail';
export const NOTIFICATION_EVENT_TYPE_PREFERENCE_UPDATE_FAIL = 'preference-updated-fail';

export const PRODUCT_CATEGORY_ANY = 'any';
